module.exports = "<div class=\"full-height-minus-search\">\n  <idap-market-filters\n  [markets] = \"markets\"\n  (onFilter) =\"onFilterChanged.next($event)\"></idap-market-filters>\n  <idap-market-table [markets]=\"filteredMarkets\"\n  (onMarketSelected)=\"marketSelected($event)\">\n  </idap-market-table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/views/market-view.component.html
// module id = ./src/app/main/views/market-view.component.html
// module chunks = main